import get from 'lodash/get';
import { Hierarchy, Vif } from '../vif';
import { getTableHierarchies } from './VifSelectors';
import { activeHierarchyIdPath } from './AgTableObjectPathHelpers';

export function findHierarchyInfo(vif: Vif, hierarchyId: string) {
  const hierarchies = getTableHierarchies(vif) ?? [];
  const hierarchyIndex = hierarchies.findIndex((h: Hierarchy) => h.id === hierarchyId);

  return {
    hierarchies,
    hierarchyIndex,
  };
}

export function getActiveHierarchyId(vif: Vif) {
  return get(vif, activeHierarchyIdPath);
}

export function getCurrentHierarchyInfo(currentVisualization: any, vif?: Vif) {
  // If no VIF is provided, use the current visualization's VIF
  const vifToUse =
    vif || (currentVisualization && currentVisualization.getVif ? currentVisualization.getVif() : null);

  if (!vifToUse) {
    return {
      hierarchies: [],
      activeHierarchyId: null,
      activeHierarchyIndex: -1,
      hierarchyConfig: null,
    };
  }
  const activeHierarchyId = getActiveHierarchyId(vifToUse);
  const { hierarchies, hierarchyIndex } = findHierarchyInfo(vifToUse, activeHierarchyId);
  const hierarchyConfig = hierarchyIndex >= 0 ? hierarchies[hierarchyIndex] : null;

  return {
    hierarchies,
    activeHierarchyId,
    activeHierarchyIndex: hierarchyIndex,
    hierarchyConfig,
  };
}
